(ns app.bulk.unsaved-confirm-modal
  "Confirmation modal shown when the user attempts to navigate away from
   the bulk scheduling page (or switch the selected Instagram account)
   while local row edits have not been saved.

   Modal `:params` shape: `{:on-confirm [<actions>...]}`. The `:on-confirm`
   chain is dispatched after the modal is closed when the user picks
   'Discard changes'.")

(defn render
  [state]
  (let [params (get-in state [:ui/modal :params])
        on-confirm (or (:on-confirm params) [])]
    [:div
     [:div
      {:class ["flex" "items-start" "gap-3"]}
      [:div
       {:class ["shrink-0" "w-10" "h-10" "rounded-full" "bg-amber-100"
                "flex" "items-center" "justify-center" "text-amber-600"]}
       [:svg {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20"
              :fill "currentColor" :class ["w-5" "h-5"]}
        [:path {:fill-rule "evenodd" :clip-rule "evenodd"
                :d "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"}]]]
      [:div
       {:class ["flex-1" "min-w-0"]}
       [:h2
        {:class ["text-lg" "font-semibold" "text-gray-900"]}
        "Discard unsaved changes?"]
       [:p
        {:class ["mt-1" "text-sm" "text-gray-600"]}
        "You have edits in this view that have not been saved yet. "
        "Continuing will discard them."]]]
     [:div
      {:class ["mt-5" "flex" "justify-end" "gap-2"]}
      [:button
       {:class ["px-4" "py-2" "rounded-md" "text-sm" "font-medium"
                "text-gray-700" "bg-white" "border" "border-gray-300"
                "hover:bg-gray-50" "cursor-pointer" "transition-colors"]
        :on {:click [[:ui/modal-close]]}}
       "Stay on page"]
      [:button
       {:class ["px-4" "py-2" "rounded-md" "text-sm" "font-medium"
                "text-white" "bg-red-600" "hover:bg-red-700"
                "cursor-pointer" "transition-colors"]
        :on {:click (into [[:ui/modal-close]] on-confirm)}}
       "Discard changes"]]]))

(def modal
  {:modal-id :modals/bulk-unsaved-confirm
   :render #'render})
